// StockHealthSkeleton.jsx
import React from "react";
import SkeletonBox from "./SkeletonBox";

export default function StockHealthSkeleton() {
  return (
    <div className="w-full h-[250px] flex flex-col items-center justify-start p-4">
      {/* Semi-circle gauge placeholder */}
      <div className="relative w-full flex items-center justify-center mt-2">
        {/* Outer half circle */}
        <div
          className="animate-pulse bg-gray-200"
          style={{
            width: 200,
            height: 100,
            borderTopLeftRadius: 200,
            borderTopRightRadius: 200,
          }}
        ></div>

        {/* Inner circle cutout */}
        <div
          className="absolute bg-gray-100 animate-pulse opacity-60"
          style={{
            width: 120,
            height: 60,
            bottom: 0,
            borderTopLeftRadius: 120,
            borderTopRightRadius: 120,
          }}
        ></div>
      </div>

      {/* Legend skeleton */}
      <div className="flex flex-wrap justify-center gap-4 mt-6">
        {[1, 2].map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            <SkeletonBox className="h-3 w-3 rounded-full" />
            <SkeletonBox className="h-3 w-14" />
          </div>
        ))}
      </div>
    </div>
  );
}
